module.exports = __webpack_public_path__ + "static/media/award_archero_mobile@2x.62203190.png";